import React from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import './PaymentPage.css';

export const PaymentPage: React.FC = () => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();

  const handleSupport = (event_: React.MouseEvent<HTMLButtonElement>): void => {
    event_.preventDefault();
    navigate('/support-center');
  };

  return (
    <div className="payment-page">
      <div className="payment-container">
        <div className="payment-header">
          <h1>{t('nav.paymentsSubscriptions')}</h1>
          <p>{t('payments.unavailableDesc')}</p>
          <button type="button" className="support-button" onClick={handleSupport}>
            {t('payments.contactSupport', 'Contact Support')}
          </button>
        </div>
      </div>
    </div>
  );
};
